import { useContext } from 'react';

import { CoveoAnalyticsContext, ICoveoAnalyticsContext } from './coveoAnalytics.context';

export const useCoveoAnalyticsConfig = (): ICoveoAnalyticsContext =>
  useContext(CoveoAnalyticsContext);
